import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { useToast } from '@/services/toast';

export function useNotifications() {
  const { t } = useTranslation();
  const toast = useToast();

  return useMemo(
    () => ({
      validationErrors() {
        toast.show({
          severity: 'error',
          summary: t('bulkDonorScheduling.toast.Validation_Errors.summary'),
          detail: t('bulkDonorScheduling.toast.Validation_Errors.detail'),
        });
      },
      validationSuccessful() {
        toast.show({
          severity: 'success',
          summary: t('bulkDonorScheduling.toast.Validation_Successful.summary'),
          detail: t('bulkDonorScheduling.toast.Validation_Successful.detail'),
        });
      },
      validationServerError() {
        toast.show({
          severity: 'error',
          summary: t(
            'bulkDonorScheduling.toast.Validation_Server_Error.summary',
          ),
          detail: t('bulkDonorScheduling.toast.Validation_Server_Error.detail'),
        });
      },
      uploadSuccessful() {
        toast.show({
          severity: 'success',
          summary: t('bulkDonorScheduling.toast.Upload_Successful.summary'),
          detail: t('bulkDonorScheduling.toast.Upload_Successful.detail'),
        });
      },
      processingSuccessful(result: {
        donorSchedulesProcessed: number;
        soSchedulesCreated: number;
        chuteSchedulesCreated: number;
        successfulRows: string;
        manualFollowUpRows: string;
      }) {
        toast.show({
          severity: 'success',
          summary: t('bulkDonorScheduling.toast.Processing_Successful.summary'),
          detail: t('bulkDonorScheduling.toast.Processing_Successful.detail', {
            donor_schedules_processed: result.donorSchedulesProcessed,
            so_schedules_created: result.soSchedulesCreated,
            chute_schedules_created: result.chuteSchedulesCreated,
            successful_rows: result.successfulRows,
            manual_follow_up_rows:
              result.manualFollowUpRows ||
              t('bulkDonorScheduling.toast.Processing_Successful.none'),
          }),
        });
      },
      uploadServerError() {
        toast.show({
          severity: 'error',
          summary: t('bulkDonorScheduling.toast.Upload_Server_Error.summary'),
          detail: t('bulkDonorScheduling.toast.Upload_Server_Error.detail'),
        });
      },
      fileProcessingError(message: string) {
        toast.show({
          severity: 'error',
          summary: t('bulkDonorScheduling.fileProcessingError'),
          detail: message,
        });
      },
      fileUploadSuccess(message: string) {
        toast.show({
          severity: 'success',
          summary: t('bulkDonorScheduling.fileUploadSuccess'),
          detail: message,
        });
      },
    }),
    [t, toast],
  );
}
